
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from 'react';
import {RemoveStackerBalance, ShowStackerBalance} from "../../../actions/terminal";
import { connect } from "react-redux";
import {ClosePopup} from "../../../actions/ui";

class StackerBalance extends Component {
    constructor (props) {
        super(props);
        this.printStackerBalance = this.printStackerBalance.bind(this);
        this.stackerBalanceShow = this.stackerBalanceShow.bind(this);
    }
    printStackerBalance () {
        return () => {
            this.props.dispatch(RemoveStackerBalance(null));
            this.props.dispatch(ClosePopup("stackerBalance"));
        };
    }
    stackerBalanceShow () {
        return () => this.props.dispatch(ShowStackerBalance(null));
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

export default connect()(StackerBalance);